(() => {
  window.dataLayer = window.dataLayer || [];
  const categories = [...document.querySelectorAll('.home-category span')].map((node) => node.textContent.trim());
  if (categories.length) window.dataLayer.push({ event: 'view_item_list', item_list_name: 'homepage_categories', items: categories });
  document.addEventListener('click', (event) => {
    const heroCta = event.target.closest('[data-home-atc]');
    if (heroCta) window.dataLayer.push({ event: 'select_promotion', promotion_name: 'homepage_hero' });
    const checkout = event.target.closest('button[name="checkout"], a[href="/checkout"]');
    if (checkout) window.dataLayer.push({ event: 'begin_checkout', source: 'cart_drawer' });
    const email = event.target.closest('.home-email__form button');
    if (email) window.dataLayer.push({ event: 'email_signup', source: 'homepage' });
  });
})();
